<mat-sidenav-container class="main-container">
    <mat-sidenav #sideNav position="end">
        <admin-support-contact (savedContact)="savedContact($event)" [sidenavin]="sideNav" [supportContact]=selectedContact></admin-support-contact>
    </mat-sidenav>
    <div class="container-fluid margin-top-10">
        <simple-grid #supportNumbersGrid [settings]=grid></simple-grid>
    </div>
</mat-sidenav-container>
